export const _environment = state => state.app.environment
